<template>
  <div class="container-fluid bg-green position-relative overflow-hidden">
       <div class="paint-left_footer pe-none d-lg-block d-none"><img src="https://wanada.org.au/wp-content/themes/wanada-child/img/paint-left.png"></div>
    <div class="row">
      <div class="col-48">
        <div class="container ">
          <div class="row pb-5 pt-7 px-xl-0 px-3">

     
 
 <div class="col-lg-24 col-48 text-start text-white">
       <router-link :to="{name: 'Home'}" class="gb-title text-white"><img class="logo-footer mb-5" alt="GreenBook Logo" src="@/assets/greenbook-logo.png"></router-link>
        <div class="address-footer mb-4">
   <p class="mb-0">General Enquiries</p>
   <p class="mb-0">E: <a class="" href="mailto:drugpeak@wanada.org.au">drugpeak@wanada.org.au</a></p>
   <p class="mb-0">P: <a class="" href="tel:(08) 6557 9400">(08) 6557 9400</a></p>
   </div> 
<div class="address-footer mb-4">
   <p class="mb-0">WANADA</p>
   <p class="mb-0">Whadjuk Noongar Country</p>
   <p class="mb-0">Level 1, 1 Nash St</p>
   <p class="mb-0">Perth, WA 6000</p>
   </div>
  

   <div>WANADA acknowledges Aboriginal and Torres Strait Islander peoples as the Traditional Custodians of this country and its waters. WANADA wishes to pay respect to Elders past and present and extends this to all Aboriginal people seeing this message.</div>
     </div>
  </div>

  <div class="row mb-5 text-white text-start d-flex flex-row align-items-end justify-content-between px-xl-0 px-3">
<p class="w-auto mb-lg-0 mb-5">© WANADA <a class="w-auto" href="https://loadedcommunications.com.au" target="_blank">MadebyLoaded <span class="screen-reader-only">(opens in a new tab)</span></a></p>
<a class="w-auto" href="http://www.wanada.org.au/" target="_blank"> <img class="wanada-footer" alt="WANADA Logo" :src="baseURL  + '/wanada-white-logo.png'"> <span class="screen-reader-only">(opens in a new tab)</span> </a>
  </div>
       </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
data() {
    return{
       baseURL:'https://wanada.org.au/wp-content/themes/wanada-child/img/',
    }
}
}
</script>

<style lang="scss">
// @import '@/assets/app.scss';
</style>
